import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const TextToolSidebar = (props: Props): JSX.Element => {
    return (
        <S_TextToolSidebar className={props.className}>
            <SidebarContent withTopPadding />
        </S_TextToolSidebar>
    );
};

const S_TextToolSidebar = styled.div`
    width: 100%;
`;
